import {
  CITY_DRAWER_CITY_SELECTED,
  CITY_DRAWER_RESET,
} from '@web-platform/shared-universal-constants/src/redux/actions/cityDrawer';

import type { Action } from '@web-platform/shared-universal-types/src/redux/banana/actions/actions-banana-types';
import type { CityDrawerState } from '@web-platform/shared-universal-types/src/redux/banana/state/combinedExplore/cityDrawer';

export const INITIAL_STATE: CityDrawerState = {
  selectedCityId: null,
  isDirect: null,
  postcardImageUrl: null,
  destinationSkyCode: null,
  renderTargetId: null,
};

// Temporary: All of this state slice is for the Explore E2E PoC. It can safely be removed post-PoC.
// Jira tracking this: https://skyscanner.atlassian.net/browse/EXPLORE-734
const cityDrawerReducer = (
  state: CityDrawerState = INITIAL_STATE,
  action: Action,
): CityDrawerState => {
  switch (action.type) {
    case CITY_DRAWER_CITY_SELECTED:
      return {
        ...state,
        selectedCityId: action.payload.cityId,
        isDirect: action.payload.isDirect,
        postcardImageUrl: action.payload.postcardImageUrl ?? null,
        destinationSkyCode: action.payload.destinationSkyCode,
        renderTargetId: action.payload.renderTargetId ?? null,
      };
    case CITY_DRAWER_RESET:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default cityDrawerReducer;

export const get = (state: CityDrawerState): CityDrawerState => state;
